import { useState, useCallback, useEffect } from 'react';

function debounce(fn, ms = 0) {
    let timer;
    return () => {
        if (timer !== null) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            timer = null;
            fn();
        }, ms);
    };
}
function useBreakpoint({ min, max, includeMin, includeMax, visibleOnInit = true }) {
    const [visible, setVisible] = useState(visibleOnInit);
    const onResize = useCallback(debounce(() => {
        let width = window.innerWidth;
        let _max = max || Infinity;
        let _min = min || 0;
        let MaxOK = includeMax ? width <= _max : width < _max;
        let MinOK = includeMin ? width >= _min : width > _min;
        if (MaxOK && MinOK)
            setVisible(true);
        else
            setVisible(false);
    }, 50), [min, max]);
    useEffect(() => {
        onResize();
        let _onResize = onResize;
        window.addEventListener('resize', _onResize);
        return () => {
            window.removeEventListener('resize', _onResize);
        };
    }, [onResize]);
    return visible;
}

export { useBreakpoint };
//# sourceMappingURL=useBreakpoint.js.map
